

class NuAccordionItemHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
        this.boundtoggle = this.toggle.bind( this );
    }

    connectedCallback() {
        this.toggler = this.querySelector( ':scope > button[aria-controls]' );
        this.content = this.querySelector( ':scope > [aria-labelledby]' );
        this.toggler?.addEventListener( 'click', this.boundtoggle );
    }

    disconnectedCallback() {
        this.toggler?.removeEventListener( 'click', this.boundtoggle );
    }

    toggle() {
        if ( this.hasAttribute( 'open' ) ) return this.close();
        else ( this.open() );
    }

    close() {
        this.removeAttribute( 'open' );
    }

    open() {
        this.setAttribute( 'open', '' );
    }

    onopenupdate( oldattr, newattr ) {
        if ( newattr === null ) {
            this.toggler?.setAttribute( 'aria-expanded', 'false' );
            return;
        }

        this.toggler?.setAttribute( 'aria-expanded', 'true' );

        const siblings = this.closest( 'nu-accordion-group' )?.querySelectorAll( 'nu-accordion-item' );
        siblings?.forEach( sibling => {
            if ( sibling !== this ) sibling.removeAttribute( 'open' );
        } );
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        // @ts-ignore Yes I know.
        if ( this?.[`on${name}update`] ) {
            this[`on${name}update`]( oldVal, newVal );
        }
    }
}

customElements.define( 'nu-accordion-item', NuAccordionItemHTMLElement );
